import React, { useRef } from "react";
import { Chart as ChartJS, registerables } from "chart.js";
import { Line } from "react-chartjs-2";
import CustomTooltip from "../../Common/CustomTooltip";
import zoomPlugin from 'chartjs-plugin-zoom';
import { mapDataToLabels } from "../../../utils/helper";

ChartJS.register(...registerables, zoomPlugin);

const ReviewOfferChart = (props) => {
  const { data: chartDataProps, valueProperty = "value", labels, graph3Ref, selectedOption } = props;
  // Extract data
  const [
    dataMain,
    dataFBM,
    dataAmazon,
    dataBsr,
    dataBb,
    dataOffers,
    dataRatings,
    dataReviews
  ] = chartDataProps || [];

  const fillMissingValues = (data) => {
    const filledData = [];
    let lastValue = null;

    data.forEach((value) => {
      if (value !== null) {
        lastValue = value;
      }
      filledData.push(lastValue);
    });

    return filledData;
  };

  const dataOffers_L = mapDataToLabels(dataOffers, labels, selectedOption, valueProperty);
  const dataRatings_L = mapDataToLabels(dataRatings, labels, selectedOption, valueProperty);
  const dataReviews_L = mapDataToLabels(dataReviews, labels, selectedOption, valueProperty);

  const filledOffers = fillMissingValues(dataOffers_L);
  const filledRatings = fillMissingValues(dataRatings_L);
  const filledReviews = fillMissingValues(dataReviews_L);

  const toInt = (value) => parseInt(value) || undefined;

  // const data = dataOffers?.map(d => toInt(d[valueProperty])).filter(Number.isInteger) || [];
  // dataFBM = dataRatings?.map(d => parseFloat(d[valueProperty])) || [];
  // dataBb = dataReviews?.map(d => toInt(d[valueProperty])).filter(Number.isInteger) || [];

  // const min = Math.min(...data, ...dataFBM, ...dataBb);
  // const max = Math.max(...data, ...dataFBM, ...dataBb);

  const valueFormatter = (num) => {
    if (!num) {
      return "0";
    }
    if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1) + "B";
    if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
    if (num >= 1_000) return (num / 1_000).toFixed(1) + "k";
    return num.toString();
  };

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: "Offers",
        data: filledOffers,
        borderColor: "#a78bfa",
        borderWidth: 3,
        stepped: true,
        pointRadius: 0,
        yAxisID: "y2",
      },
      // {
      //   label: "Ratings",
      //   data: filledRatings,
      //   borderColor: "#3c82f7",
      //   borderWidth: 3,
      //   stepped: true,
      //   pointRadius: 0,
      //   yAxisID: "y2",
      // },
      {
        label: "Review Count",
        data: filledReviews,
        borderColor: "#81e3d8",
        borderWidth: 3,
        stepped: true,
        pointRadius: 0,
        yAxisID: "y1",
      },
    ],
  };

  const chartOptions = {
    isReviewChart: true,
    plugins: {
      zoom: {
        zoom: {
          drag: {
            enabled: true,        
            backgroundColor: 'rgba(10,128,255,0.3)', 
          },
          mode: 'x',         
          onZoom: ({ chart }) => {
            if (props.onZoom) {
              props.onZoom(chart);
            }
          },
          onZoomComplete: ({ chart }) => {
            if (props.onZoom) {
              props.onZoom(chart);
            }
          }
        },
        limits: {
          x: { min: 'original', max: 'original' },
        }
      },
      tooltip: {
        enabled: false,
        // callbacks: {
        //   label: (context) => {
        //     const label = context.dataset.label || "";
        //     const value = context.raw || 0;
        //     return `${label}: ${valueFormatter(value)}`;
        //   },
        // },
      },
      legend: {
        display: false, // Disable legend to remove labels at the top
      },
    },
    onClick: (e, elements, chart) => {
      if (e.native.detail === 2) {
        if (props.onResetZoom) {
          props.onResetZoom();
        }
      }
    },
    scales: {
      x: {
        ticks: {
          color: "#E5E7EB", // gray-200
          font: {
            size: 9,
          },
          callback: function (value, index, ticks) {
            const fullLabel = this.getLabelForValue(value);
            const [day, month] = fullLabel.split(" ");
            return `${day} ${month}`;
          },
        },
        grid: {
          color: "rgba(229, 229, 229, 0.3)",
        },
        border: {
          color: "#E5E7EB", // gray-200
          width: 1,
        },
      },
      y1: {
        position: "left",
        ticks: {
          callback: valueFormatter,
          color: "#E5E7EB", // gray-200
        },
        grid: {
          color: "rgba(229, 229, 229, 0.3)",
        },
        border: {
          color: "#E5E7EB", // gray-200
          width: 1,
        },
      },
      y2: {
        position: "right",
        suggestedMin: 0,
        ticks: {
          callback: (value) => value.toFixed(0),
          color: "#E5E7EB", // gray-200
        },
        grid: {
          drawOnChartArea: false, // prevent grid lines from appearing over the graph
        },
        border: {
          color: "#E5E7EB", // gray-200
          width: 1,
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div
      className="bg-secondary-bg flex flex-col border border-primary/100 rounded-lg shadow-sm w-full p-1 relative"
      style={{
        minWidth: "100%",
        minHeight: "150px",
        // minHeight: '200px'
      }}
    >
      <Line
        data={chartData}
        options={chartOptions}
        style={
          {
            // minWidth: '100%'
          }
        }
        ref={(chart) => {
          if (chart) {
            graph3Ref.current = chart.chartInstance || chart;
          }
        }}
        
      />
      <CustomTooltip
        chart={graph3Ref}
        valueFormatter={valueFormatter}
        chart_type={"offers"}
      />
    </div>
  );
};

export default ReviewOfferChart;
